import React from "react"

import KnowledgeModerationButtons from "../../../common/knowledge-list/KnowledgeModerationButtons"
import FormActionButtonsWidget from "../../../common/FormActionButtonsWidget"
import FeedRejectionReasonModalContainer from "../FeedRejectionReasonModalContainer"

const EditFeedFormActionButtonsWidget = props => {
    const {
        canEdit,
        moderationStatus,
        approve,
        reject,
        unmoderate,
        isSaving,
        isRejectReasonModalOpen,
        suggestedModerationStatus,
        showModerationButtons = true,
        // The rejection reason modal moderates through its own page's state, so a page reusing these buttons passes its own
        RejectionReasonModal = FeedRejectionReasonModalContainer,
    } = props

    return (
        <FormActionButtonsWidget {...props}>
            {showModerationButtons && (
                <KnowledgeModerationButtons
                    {...{
                        canSave: canEdit,
                        isSaving,
                        moderationStatus,
                        approve,
                        reject,
                        unmoderate,
                        suggestedModerationStatus
                    }}
                />
            )}
            {isRejectReasonModalOpen && (
                <RejectionReasonModal isOpen={isRejectReasonModalOpen} />
            )}
        </FormActionButtonsWidget>
    )
}

export default EditFeedFormActionButtonsWidget
